import React, { useState, useEffect } from "react";
import "../../../styles/globalStyles.css";
import styles from "./SQLTraining.module.css";
import { SendHorizontal, CheckCircle } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import Seo from "./../../Seo";

const SQLTraining = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  useEffect(() => {
    const handleAnchorClick = (e) => {
      const target = e.target.closest('a[href^="/#"]');
      if (target && isMenuOpen) {
        closeMenu();
      }
    };

    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, [isMenuOpen]);

  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({
          behavior: "smooth"
        });
      }
    } else {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  }, [location]);

  return (
    <>
      <Seo
        title="Kurs SQL – poziom podstawowy"
        description="Szkolenie SQL dla początkujących. Naucz się tworzyć zapytania SQL, pracować z bazami danych i zdobyć praktyczne umiejętności wykorzystywane w pracy."
        canonical="/training/sql"
      />
      <section id="service" className="sectionContainer light">
        <div className={`${styles.titleTrainingSQL} "sectionTitle"`}>
          <h1>Podstawowy kurs SQL</h1>
        </div>
        <div className={styles.content}>
          {/* 1 */}
          <div className={styles.module}>
            <h2>Moduł 1</h2>
            <div className={styles.listElementsSQL}>
              <div className={styles.listItemSQL}>
                <span className={styles.iconArrow}>
                  {" "}
                  <SendHorizontal className={styles.iconArrowMobile} />
                </span>
                <span>Pojęcie i cechy bazy dnaych.</span>
              </div>
              <div className={styles.listItemSQL}>
                <span className={styles.iconArrow}>
                  {" "}
                  <SendHorizontal className={styles.iconArrowMobile} />
                </span>
                <span> Systemy zarządzania bazą danych.</span>
              </div>
              <div className={styles.listItemSQL}>
                <span className={styles.iconArrow}>
                  {" "}
                  <SendHorizontal className={styles.iconArrowMobile} />
                </span>
                <span>
                  {" "}
                  Różnice między relacyjną a nierelacyjną bazą danych.
                </span>
              </div>
              <div className={styles.listItemSQL}>
                <span className={styles.iconArrow}>
                  {" "}
                  <SendHorizontal className={styles.iconArrowMobile} />
                </span>
                <span>
                  Podstawowe pojęcia związane z relacyjną bazą danych.
                </span>
              </div>
              <div className={styles.listItemSQL}>
                <span className={styles.iconArrow}>
                  {" "}
                  <SendHorizontal className={styles.iconArrowMobile} />
                </span>
                <span>Typy relacji.</span>
              </div>
              <div className={styles.listItemSQL}>
                <span className={styles.iconArrow}>
                  {" "}
                  <SendHorizontal className={styles.iconArrowMobile} />
                </span>
                <span>Integralność danych.</span>
              </div>
              <div className={styles.listItemSQL}>
                <span className={styles.iconArrow}>
                  {" "}
                  <SendHorizontal className={styles.iconArrowMobile} />
                </span>
                <span>Normalizacja i denormalizacja.</span>
              </div>
              <div className={styles.listItemSQL}>
                <span className={styles.iconArrow}>
                  {" "}
                  <SendHorizontal className={styles.iconArrowMobile} />
                </span>
                <span>Omówienie OLTP oraz OLAP.</span>
              </div>
            </div>
          </div>

          {/* 2 */}
          <div className={styles.title}>
            <h2>Naucz się języka SQL razem z Nami.</h2>
            <h3>
              Sprawimy, że praca z danymi okaże się dla Ciebie przyjemnością.
            </h3>
          </div>

          {/* 3 */}
          <div className={styles.imageContainer}>
            <img
              src={`${process.env.PUBLIC_URL}/Images/Services/sql.webp`}
              alt="Baza danych SQL"
              className={styles.imageIcon}
            />
          </div>

          {/* 4 */}

          <div className={styles.module}>
            <h2>Moduł 2</h2>

            <div className={styles.listElementsSQL}>
              <div className={styles.listItemSQL}>
                <span className={styles.iconArrow}>
                  {" "}
                  <SendHorizontal className={styles.iconArrowMobile} />
                </span>
                <span>Zapoznanie z konstrukcją składni języka SQL.</span>
              </div>
              <div className={styles.listItemSQL}>
                <span className={styles.iconArrow}>
                  {" "}
                  <SendHorizontal className={styles.iconArrowMobile} />
                </span>
                <span>Tworzenie bazy danych z wykorzystaniem PostgreSQL.</span>
              </div>
              <div className={styles.listItemSQL}>
                <span className={styles.iconArrow}>
                  {" "}
                  <SendHorizontal className={styles.iconArrowMobile} />
                </span>
                <span> Tworzenie tabel oraz ich modyfikacja.</span>
              </div>
              <div className={styles.listItemSQL}>
                <span className={styles.iconArrow}>
                  {" "}
                  <SendHorizontal className={styles.iconArrowMobile} />
                </span>
                <span>Dodawanie danych do bazy danych.</span>
              </div>
              <div className={styles.listItemSQL}>
                <span className={styles.iconArrow}>
                  {" "}
                  <SendHorizontal className={styles.iconArrowMobile} />
                </span>
                <span>Omówienie typów danych.</span>
              </div>
              <div className={styles.listItemSQL}>
                <span className={styles.iconArrow}>
                  {" "}
                  <SendHorizontal className={styles.iconArrowMobile} />
                </span>
                <span>Omówienie ograniczeń.</span>
              </div>
              <div className={styles.listItemSQL}>
                <span className={styles.iconArrow}>
                  {" "}
                  <SendHorizontal className={styles.iconArrowMobile} />
                </span>
                <span> Tworzenie sekwencji.</span>
              </div>
            </div>
          </div>

          {/* 5 */}
          <div className={styles.module}>
            <h2>Moduł 3</h2>
            <div className={styles.listElementsSQL}>
              <div className={styles.listItemSQL}>
                <span className={styles.iconArrow}>
                  {" "}
                  <SendHorizontal className={styles.iconArrowMobile} />
                </span>
                <span>Wyszukiwanie danych z tabeli.</span>
              </div>
              <div className={styles.listItemSQL}>
                <span className={styles.iconArrow}>
                  {" "}
                  <SendHorizontal className={styles.iconArrowMobile} />
                </span>
                <span>Sortowanie wyszukiwanych danych.</span>
              </div>
              <div className={styles.listItemSQL}>
                <span className={styles.iconArrow}>
                  {" "}
                  <SendHorizontal className={styles.iconArrowMobile} />
                </span>
                <span> Grupowanie danych oraz omówienie WHERE i HAVING.</span>
              </div>
              <div className={styles.listItemSQL}>
                <span className={styles.iconArrow}>
                  {" "}
                  <SendHorizontal className={styles.iconArrowMobile} />
                </span>
                <span>Omówienie różnych rodzajów operatorów.</span>
              </div>
              <div className={styles.listItemSQL}>
                <span className={styles.iconArrow}>
                  {" "}
                  <SendHorizontal className={styles.iconArrowMobile} />
                </span>
                <span>Tworzenie tabel wykorzystując wynik zapytania.</span>
              </div>
              <div className={styles.listItemSQL}>
                <span className={styles.iconArrow}>
                  {" "}
                  <SendHorizontal className={styles.iconArrowMobile} />
                </span>
                <span> Łączenie tabel.</span>
              </div>
            </div>
          </div>

          {/*6 */}
          <div className={styles.title}>
            <h2>Nauczymy Cię tworzyć i modyfikować struktury bazodanowe.</h2>
          </div>

          <div className={styles.imageContainer}>
            <img
              src={`${process.env.PUBLIC_URL}/Images/Services/sql.webp`}
              alt="Baza danych SQL"
              className={styles.imageIcon}
            />
          </div>

          <div className={styles.module}>
            <h2>Moduł 4</h2>
            <div className={styles.listElementsSQL}>
              <div className={styles.listItemSQL}>
                <span className={styles.iconArrow}>
                  {" "}
                  <SendHorizontal className={styles.iconArrowMobile} />
                </span>
                <span>Funkcje</span>
              </div>
              <div className={styles.listItemSQL}>
                <span className={styles.iconArrow}>
                  {" "}
                  <SendHorizontal className={styles.iconArrowMobile} />
                </span>
                <span>
                  Wykorzystanie dat i czasu w tworzeniu tabel i zapytań.
                </span>
              </div>
              <div className={styles.listItemSQL}>
                <span className={styles.iconArrow}>
                  {" "}
                  <SendHorizontal className={styles.iconArrowMobile} />
                </span>
                <span>Zbiory</span>
              </div>
              <div className={styles.listItemSQL}>
                <span className={styles.iconArrow}>
                  {" "}
                  <SendHorizontal className={styles.iconArrowMobile} />
                </span>
                <span>Tworzenie podzapytań.</span>
              </div>
            </div>
          </div>

          <div className={styles.module}>
            <h2>Moduł 5</h2>
            <div className={styles.listElementsSQL}>
              <div className={styles.listItemSQL}>
                <span className={styles.iconArrow}>
                  {" "}
                  <SendHorizontal className={styles.iconArrowMobile} />
                </span>
                <span>Omówienie uprawnień.</span>
              </div>
              <div className={styles.listItemSQL}>
                <span className={styles.iconArrow}>
                  {" "}
                  <SendHorizontal className={styles.iconArrowMobile} />
                </span>
                <span>Omówienie poszczególnych poleceń.</span>
              </div>
              <div className={styles.listItemSQL}>
                <span className={styles.iconArrow}>
                  {" "}
                  <SendHorizontal className={styles.iconArrowMobile} />
                </span>
                <span>Dodawanie oraz odbieranie uprawnień.</span>
              </div>
              <div className={styles.listItemSQL}>
                <span className={styles.iconArrow}>
                  {" "}
                  <SendHorizontal className={styles.iconArrowMobile} />
                </span>
                <span>Omówienie wbudowanych ról systemowych w PostgreSQL.</span>
              </div>
            </div>
          </div>

          <div className={styles.title}>
            <h2>
              Nadamy i odbierzemy wybrane uprawnienia do bazy danych
              użytkownikom.
            </h2>
          </div>

          <div className={styles.imageContainer}>
            <img
              src={`${process.env.PUBLIC_URL}/Images/Services/sql.webp`}
              alt="Baza danych SQL"
              className={styles.imageIcon}
            />
          </div>

          <div className={styles.module}>
            <h2>Moduł 6</h2>
            <div className={styles.listElementsSQL}>
              <div className={styles.listItemSQL}>
                <span className={styles.iconArrow}>
                  {" "}
                  <SendHorizontal className={styles.iconArrowMobile} />
                </span>
                <span>Omówienie transakcji.</span>
              </div>
              <div className={styles.listItemSQL}>
                <span className={styles.iconArrow}>
                  {" "}
                  <SendHorizontal className={styles.iconArrowMobile} />
                </span>
                <span>Właściwości transakcji.</span>
              </div>
              <div className={styles.listItemSQL}>
                <span className={styles.iconArrow}>
                  {" "}
                  <SendHorizontal className={styles.iconArrowMobile} />
                </span>
                <span>Rodzaje izolacji.</span>
              </div>
              <div className={styles.listItemSQL}>
                <span className={styles.iconArrow}>
                  {" "}
                  <SendHorizontal className={styles.iconArrowMobile} />
                </span>
                <span>Omówienie pojęć związanych z transakcjami.</span>
              </div>
              <div className={styles.listItemSQL}>
                <span className={styles.iconArrow}>
                  {" "}
                  <SendHorizontal className={styles.iconArrowMobile} />
                </span>
                <span>Zarząadzanie transakcjami.</span>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.conditions}>
          <h3>Co dostajesz w ramach szkolenia:</h3>
          <ul className={styles.listOfConditions}>
            <li>
              <CheckCircle className={styles.iconCondition} />
              Każdy moduł składa się z części teoretycznej oraz praktycznej,
              dzięki czemu zdobyta wiedza jest od razu wykorzystywana w
              ćwiczeniach.
            </li>
            <li>
              <CheckCircle className={styles.iconCondition} />
              Dostosowujemy tempo pracy i sposób prowadzenia zajęć do poziomu
              oraz potrzeb uczestnika.
            </li>
            <li>
              <CheckCircle className={styles.iconCondition} /> Nie zostajesz sam
              z problemami. Pomagamy, odpowiadamy na pytania i wspieramy również
              po zakończeniu kursu.
            </li>
            <li>
              <CheckCircle className={styles.iconCondition} /> Otrzymujesz
              przygotowane materiały, do których możesz wrócić także po
              zakończeniu szkolenia.
            </li>
            <li>
              <CheckCircle className={styles.iconCondition} /> Po zakończeniu
              kursu otrzymujesz potwierdzenie zdobytych umiejętnościw formie
              certyfikatu lub zaświadczenia.
            </li>
            <li>
              <CheckCircle className={styles.iconCondition} />
              Preferujemy pracę na własnym komputerze, ponieważ dzięki temu po
              zakończeniu kursu uczestnik ma gotowe środowisko do dalszej nauki
              i samodzielnej pracy. Na pierwszych zajęciach pomagamy w
              konfiguracji sprzętu. Jeśli nie posiadasz własnego komputera,
              zapewniamy możliwość skorzystania ze sprzętu szkoleniowego.
            </li>
            <li>
              <CheckCircle className={styles.iconCondition} />
              <span className={styles.timeItem}>
                Czas trwania szkolenia: około 26 - 32 godzin dydaktycznych.
                Dokładny czas realizacji zależy od tempa pracy uczestników,
                liczby osób w grupie oraz zakresu omawianego materiału.
              </span>
            </li>
          </ul>
        </div>
        <div className={styles.additionInfoAboutContact}>
          <p>
            Jeśli masz pytania dotyczące szkolenia lub nie wiesz, który kurs
            będzie najlepszy, chętnie pomożemy. Skontaktuj się z nami{" "}
            <a href="/#contact" className={styles.contactInfo}>
              telefonicznie, przez formularz kontaktowy lub e-mail.
            </a>{" "}
            Zachęcamy również do odwiedzenia sekcji{" "}
            <a href="/#faq" className={styles.contactInfo}>
              FAQ
            </a>
            , gdzie zebraliśmy odpowiedzi na najczęściej zadawane pytania.
          </p>
        </div>
        <div className={styles.priceSection}>
          {/* <div className={styles.parameters}>
          <h2 className={styles.time}>Czas trwania kursu: </h2>
          <h1 className={styles.price}>Standardowa cena: 1100zł</h1>
        </div> */}
          {/* <div className={styles.bonus}>
            <div className={styles.promoBanner}>
              <div className={styles.promoContent}>
                <span className={styles.badge}>PROMOCJA</span>

                <h2 className={styles.user}>
                  Cena dla klientów indywidulanych.
                </h2>
                <h3 className={`${styles.price} ${styles.newPrice}`}>
                  Przedsprzedaż: 800zł
                </h3>
                <h3 className={`${styles.price} ${styles.regularPrice}`}>
                  Cena regularna: 1350zł
                </h3>
                <h3 className={styles.promoH2}>
                  Szkolenie jest teraz w <strong>promocyjnej cenie!</strong>
                </h3>
                <div className={styles.moveInfo}>
                  <h4 className={styles.promoH3}>
                    Tylko przez najbliższe <strong>2 tygodnie</strong> – nie
                    przegap!
                  </h4>
                  <Link to="/#contact" className={styles.ctaButton}>
                    Zapisz się!
                  </Link>
                </div>
              </div>
            </div>
          </div> */}
          <div className={styles.bonus}>
            <div className={styles.promoBanner}>
              <div className={styles.promoContent}>
                <h2 className={styles.user}>
                  Cena dla klientów indywidualnych.
                </h2>
                <h2 className={`${styles.price} ${styles.newPrice}`}>
                  Cena: 1450 zł
                </h2>
                <Link to="/#contact" className={styles.ctaButton}>
                  Zapisz się!
                </Link>
              </div>
            </div>
          </div>
          {/* <div className={styles.bonus}>
            <div className={styles.promoBanner}>
              <div className={styles.promoContent}>
                <span className={styles.badge}>PROMOCJA</span>

                <h2 className={styles.user}>Cena dla grup od 2 do 6 osób.</h2>
                <h3 className={`${styles.price} ${styles.newPrice}`}>
                  Przedsprzedaż: 900zł
                </h3>
                <h3 className={`${styles.price} ${styles.regularPrice}`}>
                  Cena regularna: 1450zł
                </h3>
                <h3 className={styles.promoH2}>
                  Szkolenie jest teraz w <strong>promocyjnej cenie!</strong>
                </h3>
                <div className={styles.moveInfo}>
                  <h4 className={styles.promoH3}>
                    Tylko przez najbliższe <strong>2 tygodnie</strong> – nie
                    przegap!
                  </h4>
                  <Link to="/#contact" className={styles.ctaButton}>
                    Zapisz się!
                  </Link>
                </div>
              </div>
            </div>
          </div> */}
          <div className={styles.bonus}>
            <div className={styles.promoBanner}>
              <div className={styles.promoContent}>
                <h2 className={styles.user}>Cena dla grup <br />od 2 do 6 osób.</h2>
                <h2 className={`${styles.price} ${styles.newPrice}`}>
                  Cena: 1350 zł
                </h2>
                <Link to="/#contact" className={styles.ctaButton}>
                  Zapisz się!
                </Link>
              </div>
            </div>
          </div>
          <div className={styles.bonus}>
            <div className={styles.promoBanner}>
              <div className={styles.promoContent}>
                {/* <span className={styles.badge}>PROMOCJA</span> */}

                <h2 className={styles.user}>Szkolenie dla firm i instytucji</h2>
                <h2 className={`${styles.price} ${styles.newPrice}`}>
                  Cena ustalana jest indywidualnie w zależności od potrzeb
                  firmy.
                </h2>
                <Link to="/#contact" className={styles.ctaButton}>
                  Zapisz się!
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* <div className={styles.saveButtonSection}>
        <div className={styles.saveButtonContainer}>
          <button className={styles.saveButton}>
            <Link to="/#contact" className={styles.saveButtonLink}>
              Zapisz się!
            </Link>
          </button>
        </div>
      </div> */}

        {/* <div className={styles.saveButtonSection}>
        <div className={styles.saveButtonContainer}>
          <h1 className={styles.price}>Cena: 600zł</h1>
          <button className={styles.saveButton}>
            <Link to="/#contact" className={styles.saveButtonLink}>
              Zapisz się!
            </Link>
          </button>
        </div>
      </div> */}
        <p className={styles.toSumUp}>
          Praca na bazach danych potrafi być fascynująca i ciekawa. Zapraszamy
          Cię na nasze szkolenie, abyśmy wspólnie mogli to odkrywać.
        </p>
        <div className="buttonSection" onClick={() => window.history.back()}>
          <div className="backButtonContainer">
            <button className="backButton">Powrót</button>
          </div>
        </div>
      </section>
    </>
  );
};
export default SQLTraining;
